import { manifestDataMatrix } from './datamatrix/dataMatrix.Manifest';
import { manifestHistogram } from './histogram/histogram.Manifest';
import { manifestScatterPlot } from './scatterplot/scatterPlot.Manifest';
import { manifestBargraph } from './bargraph/bargraph.Manifest';
import { manifestPiechart } from './piechart/piechart.Manifest';
import { manifestStripplot } from './stripplot/stripplot.Manifest';
import { manifestSunBurst } from './sunburst/sunBurst.Manifest';
import { manifestDataTable } from './datatable/dataTable.Manifest';
import { TpChartManifest } from './interfaces';
import { manifestContingencyTable } from './contingencytable/contingencyTable.Manifest';
import { manifestFacetCategorical } from './facet-categorical/facetCategorical.Manifest';
import { manifestColorLegendCategorical } from './colorLegend-categorical/colorLegendCategorical.Manifest';
import { manifestNetwork } from './network/network.Manifest';
import { manifestCorrelogram } from './correlogram/correlogram.Manifest';
import { manifestUpsetPlot } from './upset-plot/upsetPlot.Manifest';
import { manifestStackedCompositionPlot } from './stacked-composition-plot/stackedCompositionPlot.Manifest';
import { manifestLongitNumerical } from './longitudinal-numerical/longitNumerical.Manifest';
import { manifestParallelCoordinates } from './parallel-coordinates/parallelCoordinates.Manifest';
import { manifestViolinplot } from './violinplot/violinplot.Manifest';
import { getUserError } from '../../../components/miscUtils';
import { manifestMultiNumericalPunchCard } from './multinumerical-punchcard/multiNumericalPunchCard.Manifest';
import { manifestAggregatedCoordinates } from './aggregated-coordinates/aggregatedCoordinates.Manifest';

export const allChartTypeManifests = [
  manifestHistogram,
  manifestBargraph,
  manifestScatterPlot,
  manifestPiechart,
  manifestStripplot,
  manifestViolinplot,
  manifestSunBurst,
  manifestDataMatrix,
  manifestStackedCompositionPlot,
  manifestContingencyTable,
  manifestNetwork,
  manifestUpsetPlot,
  manifestParallelCoordinates,
  manifestMultiNumericalPunchCard,
  manifestColorLegendCategorical,
  manifestLongitNumerical,
  manifestCorrelogram,
  manifestFacetCategorical,
  manifestDataTable,
  manifestAggregatedCoordinates,
];

const manifestLookup: { [id: string]: TpChartManifest } = {};
for (const manifest of allChartTypeManifests) manifestLookup[manifest.id] = manifest;

export function chartFactory(chartType: string): TpChartManifest {
  if (!manifestLookup[chartType]) throw getUserError(`Invalid chart type: ${chartType}`);
  return manifestLookup[chartType];
}

export const chartTypeListForUserCreation = [
  'Histogram',
  'FacetCategorical',
  'BarGraph',
  'PieChart',
  'ScatterPlot',
  'StripPlot',
  'ContingencyTable',
  'ColorLegendCategorical',
  'UpsetPlot',
  'ViolinPlot',
  'ParallelCoordinates',
  'AggregatedCoordinates',
  'MultiNumericalPunchCard',
];

export const chartTypeListForEditCreation = [
  ...chartTypeListForUserCreation,
  'SunBurst',
  'DataMatrix',
  'CompositionPlot',
  'Network',
];
